module.exports = __webpack_public_path__ + "img/wg.b5442012.jpg";